import { combineReducers } from 'redux';
 
import savingsPotCalculatorForm from './savingsPotCalculator';
import scrolling from './scrolling';

export const savingsPotCalculator = combineReducers({
    savingsPotCalculatorForm,
    scrolling,
});